import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Reservation, Reservations } from '../interfaces/reservation';
import { ReservationSelection, ReservationSelectionCreate } from '../interfaces/reservation-selection';

interface applyCodeResponse {
  reservation: Reservation;
  message: string;
  discountAmount: number;
  discountApplied: boolean;
  affiliateName?: string;
  remainingUserUses?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ReservationsService {

  constructor(private https: HttpClient) { }

  getReservations(){
    return this.https.get<Reservations>(environment.apiUrl+"reservations/user");
  }

  reserveEvent(id:number){
    return this.https.post<Reservation>(`${environment.apiUrl}reservations/events/${id}`, {});
  }

  customReservation(selections: ReservationSelectionCreate[]) {
    return this.https.post<Reservation>(`${environment.apiUrl}reservations/custom`, { selections });
  }

  processCart(cart: any) {
    return this.https.post<any>(`${environment.apiUrl}reservations/cart`, cart);
  }

  getReservation(locator:string){
    return this.https.get<Reservation>(`${environment.apiUrl}reservations/user/${locator}`);
  }

  getReservationDetails(locator:string){
    return this.https.get<Reservation>(`${environment.apiUrl}reservations/details/user/${locator}`);
  }
  
  applyDiscount(locator: string, discountCode: string) {
    return this.https.post<applyCodeResponse>(`${environment.apiUrl}discount-code/apply/${locator}`, {discountCode:discountCode});
  }

  // onPayNow(locator: string){
  //   return this.https.patch<Reservation>(`${environment.apiUrl}reservations/${locator}/pay`, {});
  // }
}
